import { actions } from '../../utils/constants';
import cuid from 'cuid';

export default (state = [], { type, payload }) => {
    const newState = [...state];

    switch (type) {

        case actions.REQUEST_ERROR:
            if (!payload.hidden) {
                newState.push({
                    message: payload.message,
                    title: 'Erro',
                    key: cuid(),
                    dismissAfter: 3000,
                    titleStyle: { display: 'flex', marginBottom: '3px' },
                    barStyle: { padding: '.6rem 1.4em', color: '#a94442', border: '1px solid #ebccd1', backgroundColor: '#f2dede' },
                });
            }
            return newState;

        case actions.DISMISS_NOTIFICATION:
            return newState
                .filter(n => n !== payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/notifications/notifications.reducer.js